import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import AppIcon from "./components/AppIcon.vue";
import AppModal from "./components/AppModal.vue";
import "./assets/main.css";

createApp(App)
  .use(store)
  .use(router)
  .component("AppIcon", AppIcon)
  .component("AppModal", AppModal)
  .mount("#app");
